import NeedHelpBanner from "@core-components/help-banner/NeedHelpBanner";
import ReviewCarousel from "@core-components/reviews/ReviewCarousel";
import reviews from "@core-components/reviews/defaultReviews";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { useAppRegion } from "@hooks/region/useAppRegion";
import { Stack } from "@mantine/core";
import LoLFAQ from "@modules/lol/faq/LoLFAQ";
import SEO from "@modules/seo/SEO";
import { SkinChampionSkins } from "../components/SkinChampionSkins";
import { SkinDetailsGrid } from "../components/SkinDetailsGrid";
import { SkinFeatures } from "../components/SkinFeatures";
import { SkinHero } from "../components/SkinHero";
import { SkinInfoArea } from "../components/SkinInfoArea";
import SkinProducts from "../components/SkinProducts";
import { useSkinProducts } from "../hooks/useSkinProducts";

const SkinPage: React.FC = () => {
  const { t } = useAppTranslation("pages.skins.skin");
  const {
    skin,
    champion,
    skinProducts,
    selectedProduct,
    setSelectedProduct,
    unavailableIds,
    handleRegionChange,
    handleOnBuy,
    isOutOfStock,
  } = useSkinProducts();
  const { currentRegion } = useAppRegion();

  return (
    <div>
      <SEO
        description={t("seo.description", { name: skin?.name })}
        title={t("seo.title", { name: skin?.name ?? "" })}
      />
      <SkinHero skinName={skin?.name} />

      <Stack
        align="center"
        className="relative mt-16 w-full gap-y-16 bg-primary-background px-3"
      >
        {skin && (
          <SkinProducts
            skin={skin}
            region={currentRegion}
            handleRegionChange={handleRegionChange}
            skinProducts={skinProducts}
            selectedProduct={selectedProduct}
            setSelectedProduct={setSelectedProduct}
            unavailableIds={unavailableIds}
            handleBuy={handleOnBuy}
            isOutOfStock={isOutOfStock}
          />
        )}

        <SkinDetailsGrid skin={skin} />

        <SkinInfoArea skinName={skin?.name} />

        <SkinChampionSkins
          champion={champion}
          currentSkinSlug={skin?.slug}
          onRegionChange={handleRegionChange}
        />

        <NeedHelpBanner />

        <SkinFeatures />

        <ReviewCarousel reviews={reviews} />
        <LoLFAQ />
      </Stack>
    </div>
  );
};

export default SkinPage;
